import TagManager from 'react-gtm-module';

interface EventConfig {
  event: string;
  event_name: string;
}

interface DataLayerProps {
  [key: string]: any;
}

const PORTAL_NEWS_PATH = '/portal/news';

const PAGE_EVENT_MAP: Record<string, EventConfig> = {
  [PORTAL_NEWS_PATH]: {
    event: 'trackEvent-portalNewsSearchResult',
    event_name: 'view_portal_news_search_results',
  },
};

const getEventByPage = (): EventConfig | null => {
  const path = window.location.pathname;

  if (path.startsWith(PORTAL_NEWS_PATH)) {
    return PAGE_EVENT_MAP[PORTAL_NEWS_PATH];
  }

  return null;
};

export const triggerFilterSearchResult = (datalayerProps: DataLayerProps): void => {
  const dataLayer = {
    event: 'trackEvent-filterSearchResult',
    event_name: 'filter_search_results',
    ...datalayerProps,
  };

  TagManager.dataLayer({ dataLayer });
};

export const triggerSearchResult = (datalayerProps: DataLayerProps): void => {
  const event = getEventByPage();

  if (!event) {
    return;
  }

  const dataLayer = {
    ...event,
    ...datalayerProps,
  };

  TagManager.dataLayer({ dataLayer });
};
